module.exports = __webpack_public_path__ + "img/location.33fab2b3.svg";